import { render } from "./saberPungli.vue?vue&type=template&id=08a64f7f"
import script from "./saberPungli.vue?vue&type=script&lang=js"
export * from "./saberPungli.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__